import { render } from "./student-breadcrumb.vue?vue&type=template&id=245b9b30"
import script from "./student-breadcrumb.vue?vue&type=script&lang=js"
export * from "./student-breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__